/** Public GLBs have a one-year cache lifetime; revised materials need a new URL. */
export function modelAssetUrl(src: string): string {
  return src === '/models/crystal-gem-airpods-pro.glb'
    ? `${src}?v=crystal-texture-3`
    : src
}
